document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.how-to-apply-section');

  sections.forEach(function (section) {
    const leftContent = section.querySelector('.left-content');
    const imageGallery = section.querySelector('.image-gallery');

    const isLeftContentEmpty = !leftContent || !leftContent.innerHTML.trim();
    const isImageGalleryEmpty = !imageGallery || !imageGallery.innerHTML.trim();

    if (isLeftContentEmpty && isImageGalleryEmpty) {
      section.remove();
    }
  });
    const shopifyAppBlock = document.querySelector('.product__info-wrapper .shopify-app-block');
    const noJsHidden = document.querySelector('.product__info-wrapper .no-js-hidden');

    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('wrapper-class');

    shopifyAppBlock.parentNode.insertBefore(wrapperDiv, shopifyAppBlock);
    wrapperDiv.appendChild(shopifyAppBlock);
    wrapperDiv.appendChild(noJsHidden);
    var accordionTabs = document.querySelectorAll('.product__accordion.accordion');
    accordionTabs.forEach(function(tab) {
        // Find the 'inner' div inside accordion__content
        var innerDiv = tab.querySelector('.accordion__content .inner');

        // Check if the inner div is empty
        if (innerDiv && innerDiv.innerHTML.trim() === '') {
            // Hide the entire accordion-tab
            tab.style.display = 'none';
        }
    });
      var labels = document.querySelectorAll('label.color__swatch');

    labels.forEach(function(label) {
        label.addEventListener('click', function() {
            // URL to fetch data
            var url = window.location.href;

            // Create a new XMLHttpRequest object
            var xhr = new XMLHttpRequest();
            
            // Configure it: GET-request for the URL
            xhr.open('GET', url, true);
            
            // Set up the callback to handle the response
            xhr.onload = function() {
                if (xhr.status >= 200 && xhr.status < 300) {
                     var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = xhr.responseText;

                    var newIngredientsContent = tempDiv.querySelector('.product__accordion.accordion .accordion__content .ingredients');
                    var newHowToContent = tempDiv.querySelector('.product__accordion.accordion .accordion__content .how_to');

                    var ingredientsContent = document.querySelector('.product__accordion.accordion .accordion__content .ingredients');
                    if (ingredientsContent && newIngredientsContent) {
                        ingredientsContent.innerHTML = newIngredientsContent.innerHTML;
                    }

                    var howToContent = document.querySelector('.product__accordion.accordion .accordion__content .how_to');
                    if (howToContent && newHowToContent) {
                        howToContent.innerHTML = newHowToContent.innerHTML;
                    }
                } else {
                    console.error('Error:', xhr.statusText);
                }
            };

            // Handle errors
            xhr.onerror = function() {
                console.error('Request failed');
            };

            // Send the request
            xhr.send();
        });
    });
   const menuElements = document.querySelectorAll('.menu-opening');
    const menuItems = document.querySelectorAll('.menu-drawer__menu-item');
    const firstLi = document.querySelector('.menu-drawer__menu-item:first-child');
    const header__icon  = document.querySelector('.header__icon');
  // Check if the first <li> element is found
  header__icon.addEventListener('click', function() {
       menuElements.forEach(element => {
    element.setAttribute('open','');
   element.classList.add('menu-opening');      
});
  if (firstLi) {
    // Create a new mouse click event
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });

    // Dispatch the click event on the first <li> element
    firstLi.dispatchEvent(clickEvent);
  }
     });
    menuItems.forEach(function(item) {
        item.addEventListener('click', function() {
            // Find all details elements
            const detailsElements = document.querySelectorAll('details');
            // Filter out the details elements that are immediate children of the clicked menu item
            detailsElements.forEach(function(details) {
                if (details.parentNode === item) {
                  details.toggleAttribute('open');
                }
            });
        });
    });
});




document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".static-checkout-button").forEach(function (btn) {

    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const $this = this;

      // add loading class
      $this.classList.add("loading");

      // get parent form
      const form = $this.closest("form");
      if (!form) {
        $this.classList.remove("loading");
        return;
      }

      // get variant id
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) {
        $this.classList.remove("loading");
        return;
      }

      const variantId = variantInput.value;

      // get quantity
      const quantityInput = form.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? quantityInput.value : 1;

      // add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(() => {
        // remove loading class
        $this.classList.remove("loading");

        // redirect to checkout
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error(error);
        $this.classList.remove("is-loading");
      });

    });

  });

});
